import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { NzNotificationService } from "ng-zorro-antd";
import { StringUtils } from '@ark-libs/ngx-utils';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    private lastMessages: { message: string, time: Number }[] = [];

    constructor(private injector: Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(tap(event => this.handle(event), error => this.handle(error)));
    }

    private handle(event: any) {
        if (event instanceof HttpErrorResponse && event.status != 401) {
            const message = this.parseErrorMessage(event);
            if (StringUtils.isNotEmpty(message)) {
                setTimeout(() => {
                    if (this.isDuplicate(message)) return;
                    this.lastMessages.unshift({ message: message, time: (new Date()).getTime() });
                    const notificationService = this.injector.get(NzNotificationService);
                    notificationService.error('错误', message);//, {nzDuration:5000}
                }, 500);
            }
        }
        return event;
    }

    // 忽略短时间之内相同的提示信息
    private isDuplicate(message: string): Boolean {
        if (message == null || this.lastMessages.length == 0) return false;

        while (this.lastMessages.length > 10) this.lastMessages.pop() // 只保留10条
        for (let i = 0; i < this.lastMessages.length; i++) {
            const lastMessage = this.lastMessages[i];
            if (lastMessage.message == message && lastMessage.time > (new Date()).getTime() - 5000) return true;
        }
        return false;
    }
    private parseErrorMessage(response: HttpErrorResponse): string {
        // console.error("ErrorHandlerInterceptor -> ", response);
        const error = response.error || this.getHeaderError(response) || response;
        // 这里需要做兼容性判断，以兼容多个历史版本的返回消息处理
        if (response.status == 404 || error.status == '404') return null;
        let title = error.detail || error.message || error.title;
        if (title) return title;

        title = error.error || response.statusText;
        if (response.status == 403 && (title == 'Forbidden' || title == 'OK')) return "没有权限";

        const message = error.error_description || error.message || response.message;
        return (title == message ? '' : ' [ ' + title + ' ] ') + message;
    }

    private getHeaderError(response: HttpErrorResponse): any {
        const headers = response.headers.keys().filter(name => name.toLowerCase().endsWith('app-errors'));
        if (headers.length > 0) {
            const message = response.headers.get(headers[0]);
            if (message && typeof message === 'string')
                return {
                    title: decodeURIComponent(message),
                    status: response.status
                };
        }
        return null;
    }
}
